var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 32.02v4l20-11.55 20 11.55v-4L24 20.47 4 32.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.04v4l20-11.55 20 11.55v-4L24 10.49 4 22.04z"
  })));
};
export { SvgUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYjIzYjFhOTctNzY5OC00ODQyLTg5YzEtMzAzNGRiZjM5Njk2IiBkYXRhLW5hbWU9IiZsdDtMYXllciZndDsiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+dXA8L3RpdGxlPjxwb2x5Z29uIHBvaW50cz0iNCAzMi4wMiA0IDM2LjAyIDI0IDI0LjQ3IDQ0IDM2LjAyIDQ0IDMyLjAyIDI0IDIwLjQ3IDQgMzIuMDIiLz48cG9seWdvbiBwb2ludHM9IjQgMjIuMDQgNCAyNi4wNCAyNCAxNC40OSA0NCAyNi4wNCA0NCAyMi4wNCAyNCAxMC40OSA0IDIyLjA0Ii8+PC9zdmc+Cg==";